<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="4" style="text-align: start">
                <strong v-if="status_form==0">پرسنل جدید</strong>
                <strong v-else>ویرایش پرسنل</strong>
              </CCol>
              <CCol col="4" style="text-align: center ;">

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="status_form ==0" @click="insert_data()"
                         type="submit" size="sm" class="mr-1 ml-1"  color="secondary">
                  افزودن
                </CButton>
                <CButton v-if="status_form !=0" @click="insert_data()"
                         type="submit" size="sm" color="secondary">
                 ویرایش
                </CButton>

              </CCol>
            </CRow>
          </CCardHeader>
          <CRow>

            <CCol col="12">
              <CCardBody>
                <CRow>
                  <CCol col="3">
                    <CInput
                        label="نام"

                        v-model="record_data.first_name"
                    />
                  </CCol>
                  <CCol col="3">
                    <CInput
                        label="نام خانوادگی"

                        v-model="record_data.last_name"
                    />
                  </CCol>
                  <CCol col="3">
                    <CInput
                        label="شماره همراه"

                        v-model="record_data.mobile"
                    />
                  </CCol>
                  <CCol col="3">
                    <CInput
                        label="کد ملی"

                        v-model="record_data.national_code"
                    />
                  </CCol>
                  <CCol col="3">
                    <CInputCurrency
                        label="حقوق"

                        v-model="record_data.salary"
                    />
                  </CCol>
                  <CCol col="3">
                    <CInput
                        label="شناسه دستگاه حضور غیاب"

                        v-model="record_data.present_id"
                    />
                  </CCol>
                  <CCol col="3">
                    <CSelect
                        label="وضعیت تاهل"
:options="[{label:'مجرد',value:0},{label:'متاهل',value:1}]"
                        :value.sync="record_data.married"
                    />
                  </CCol>
                  <CCol col="3">
                    <p>تاریخ قرار داد</p>
                    <date-picker
                        v-model="record_data.contract_date"
                        display-format="jYYYY/jMM/jDD"
                        format="YYYY-MM-DD"
                    />
                  </CCol>

                  <CCol col="3">
                    <CInput
                        label="تعداد فرزند"

                        v-model="record_data.child_no"
                    />
                  </CCol>

                  <CCol col="3">
                    <CSelect
                        label="وضعیت بیمه"
                        :options="[{label:'دارد',value:1},{label:'ندارد',value:0}]"
                        :value.sync="record_data.insurance"
                    />
                  </CCol>
                  <CCol col="4">
                    <CInput label="آدرس" v-model="record_data.address"/>

                  </CCol>


                </CRow>
              </CCardBody>

            </CCol>

          </CRow>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name: "confirm_brand" + new Date().getTime() + "_" + this.$vnode.tag,
      record_data:{
        married:0,
        first_name:'',
        last_name:'',
        national_code:'',
        address:'',
        contract_date:'',
        child_no:'0',
        mobile:'',
        present_id:'',
        insurance:1,
        salary:'',
      },
      collapseDuration: 0,
      status_form: 0
    }
  }, mounted() {
    this.$root.root_validate_errors = [];
if(this.$route.params.id !=null){
  this.status_form = this.$route.params.id
  this.get_info();
}

  }, watch: {

  },
  methods: {

    edit_item(item) {
      this.edit_name = item.brandName;
      this.name = item.brandName;
      this.color = item.color;
      this.description = item.description;
      this.previewImage = this.$root.base_url+'/'+item.imageName;
      this.status_form = item.id;

    },
    get_info() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      formData.append('id', this.$route.params.id);


      axios.post('/get_personnel_info',formData, {})
          .then(function (response) {

         self.record_data = response.data;


      })
          .catch(function (error) {

            console.log(error);
          });

    },


    insert_data() {
      // if (!this.validateForm()) {
      //   console.log("validate form is false" + this.validate_errors);
      //   return true;
      // }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "add_personnel";
      } else {
        url = "edit_personnel";
        formData.append('id', this.status_form)
      }

      formData.append('record_data', JSON.stringify(this.record_data));
      axios.post(url, formData, {}).then((res) => {


        self.$root.modal_component.show_api_response_modals(res);
self.$router.push({path:'/dashboard/personnel/list'})
      })
          .catch(function (error) {
            console.log(error);
            self.$root.modal_component.show_danger_modal("خطا","لطفا اطلاعات را بدرستی وارد کنید");

          });

    },
  }
}

</script>
